import { render, staticRenderFns } from "./AddressListRight.vue?vue&type=template&id=497ab7e8&scoped=true"
import script from "./AddressListRight.vue?vue&type=script&lang=js"
export * from "./AddressListRight.vue?vue&type=script&lang=js"
import style0 from "./AddressListRight.vue?vue&type=style&index=0&id=497ab7e8&lang=css"
import style1 from "./AddressListRight.vue?vue&type=style&index=1&id=497ab7e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ab7e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497ab7e8')) {
      api.createRecord('497ab7e8', component.options)
    } else {
      api.reload('497ab7e8', component.options)
    }
    module.hot.accept("./AddressListRight.vue?vue&type=template&id=497ab7e8&scoped=true", function () {
      api.rerender('497ab7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/AddressListRight.vue"
export default component.exports